/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { swalMessages } from 'src/constants';
import adminInventoryService from 'src/services/adminInventoryService';
import UserDestinatairePage from 'src/pages/AdminControl/UserDestinatairePage/UserDestinatairePage';
import filterArray from 'src/utils/filterArray';
import { Context } from 'src/context/Contex';
import * as paths from 'src/routes/paths';
import swal from 'sweetalert';

function defaultValues() {
  return {
    nombre: '',
    correo: '',
    apellido: '',
    id: '',
    contraseña: '',
  };
}

const UserDestinataireContainer = () => {
  const [destinataire, setDestinataire] = useState([]);
  const [destinataries, setDestinataries] = useState([]);
  const [checkPassword, setCheckPassword] = useState(false);
  const [user, setUser] = useState(defaultValues());
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const { userId } = useContext(Context);
  const history = useHistory();

  if (userId.id === undefined) {
    history.push(paths.ADMIN_USERS_INVENTORY);
  }

  const reloadUser = async () => {
    const response = await adminInventoryService.getUser(userId.id);
    setUser(response);
  };

  const reloadUserDestinatarie = async () => {
    const response = await adminInventoryService.getUserDestinatarie(userId.id);
    setDestinataire(response);
  };

  const reloadAllDestinataries = async () => {
    const response = await adminInventoryService.getAllDestinataries();
    setDestinataries(response);
  };

  const checkUpdatePassword = () => {
    if (user.contraseña?.length <= 7) {
      setCheckPassword(false);
    }
    if (user.contraseña?.length >= 8) {
      setCheckPassword(true);
    }
    return checkPassword;
  };

  const handleChangeValue = (value, type) => {
    setUser({ ...user, [type]: value });
    checkUpdatePassword();
  };

  const handleUpdateUser = async (event) => {
    event.preventDefault();
    const response = await adminInventoryService.updateUser(user);
    if (response.success === 0) {
      swal(swalMessages.GENERAL_ERROR);
    } else {
      swal(swalMessages.SUCCESSFUL_MESSAGE);
    }
  };

  const handleUpdatePassword = async () => {
    if (checkUpdatePassword()) {
      await adminInventoryService.updatePassword({
        id: userId.id,
        clave: user.contraseña,
      });
    }
  };

  const handleSearchDestinatary = (event) => {
    setSearch(event.target.value);
  };

  const handleAddDestinataire = (item) => async () => {
    const index = destinataire.findIndex(
      (destinatary) => destinatary.destinatario_id === item.Cliente_Destinatario,
    );

    if (index === -1) {
      setDestinataire([
        ...destinataire,
        { ...item, destinatario_id: item.Cliente_Destinatario },
      ]);
      await adminInventoryService.addDestinataire({
        destinatario_id: item.Cliente_Destinatario,
        usuario_id: userId.id,
      });
    }
  };

  const handleDeleteDestinatarie = (item) => async () => {
    const response = await adminInventoryService.deleteDestinataire(item.id);
    if (response.success === 1) {
      reloadUserDestinatarie();
    }
  };

  useEffect(() => {
    Promise.all([
      reloadUser(),
      reloadAllDestinataries(),
      reloadUserDestinatarie(),
    ]).then(() => {
      setLoading(false);
    });
    setLoading(true);
  }, []);

  const filtered = filterArray(
    destinataries,
    'Nombre_Cliente_Destinatario',
    search,
  );

  return (
    <UserDestinatairePage
      user={user}
      search={search}
      loading={loading}
      checkPassword={checkPassword}
      destinataries={filtered}
      destinataire={destinataire}
      handleDeleteDestinatarie={handleDeleteDestinatarie}
      handleSearchDestinatary={handleSearchDestinatary}
      handleAddDestinataire={handleAddDestinataire}
      handleUpdatePassword={handleUpdatePassword}
      handleChangeValue={handleChangeValue}
      handleUpdateUser={handleUpdateUser}
    />
  );
};

export default UserDestinataireContainer;
